export default "<router-outlet></router-outlet>\n<app-login></app-login>\n<ng-snotify></ng-snotify>\n"